module.exports = __webpack_public_path__ + "fa-light-300.79f0a37f306d2fd0c8e3.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-light-300.svg
// module id = ../../../../../src/assets/fonts/webfonts/fa-light-300.svg
// module chunks = styles